import React from 'react';
import { formatRelativeTime } from '../utils/time';

/**
 * "5m ago" that keeps itself current. A label computed once at render goes
 * on saying "2m ago" for as long as the page stays open.
 */
export function useRelativeTime(
  value: string | Date | null | undefined,
  intervalMs: number = 30000,
): string | null {
  const [now, setNow] = React.useState(() => Date.now());

  React.useEffect(() => {
    if (!value) return undefined;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [value, intervalMs]);

  return formatRelativeTime(value, now);
}
